import React, { useEffect } from "react";

import UnitBodySh from "./UnitBodySh";
import UnitOfferSaleSh from "./UnitOfferSaleSh";
import { type Unit } from "../../../store/slices/unitsSlice";
import { type ISettings } from "../../../store/slices/userSlice";
import UnitArchiveButtonSh from "./UnitArchiveButtonSh";
import useUserType from "../../../hooks/UseUserType";
import { USER_ID_KEY } from "../../../urls";
import { getUnitSourceBadgeText } from "../../../functions/shared/units/getUnitSourceCategory";

interface IProps {
    hide: boolean;
    unit: Unit;
    fromEntry: string | undefined;
    settings?: ISettings[];
}

//export default
function UnitSh({
    hide,
    unit,
    fromEntry,
    settings,
}: IProps): JSX.Element {

    const userID = window.localStorage.getItem(USER_ID_KEY) ?? ''
    const cardBadgeText = getUnitSourceBadgeText(unit)


    return (
        <div className="card shadow-sm mb-4 position-relative h-100 d-flex flex-column">
            <div className="d-flex justify-content-end position-absolute" style={{ zIndex: 10 }}>
                <div className="btn btn-sm btn-bso btn-active-bso p-0 px-2 m-0 mb-1 text-truncate">
                    {cardBadgeText}
                </div>
            </div>
            {unit?.attributes.User.data?.id === Number(userID) && (
                <UnitArchiveButtonSh unit={unit} />
            )}
            <UnitOfferSaleSh hide={hide} unit={unit} />
            <UnitBodySh unit={unit} fromEntry={fromEntry} settings={settings} />
        </div>
    );
}

export default React.memo(UnitSh);
